import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import catalog from './views/catalog.vue'
import project from './views/project.vue'
import errorPage from './views/404.vue'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/catalog/:id?',
      name: 'catalog',
      //component: catalog,
      component: () => import(/* webpackChunkName: "catalog" */ './views/catalog.vue'),
      props: true
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "catalog" */ './views/dashboard.vue'),
    },
    {
      path: '/dashboard/projects',
      name: 'dashboard-projectList',
      component: () => import(/* webpackChunkName: "catalog" */ './views/dashboard.vue'),
    },
    {
      path: '/project',
      name: 'project',
      // route level code-splitting
      // this generates a separate chunk (project.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: project
      //component: () => import(/* webpackChunkName: "project" */ './views/project.vue')
    },

    { 
      path: '/prices',
      name: 'prices',
      component: () => import(/* webpackChunkName: "help" */ './views/prices.vue')
    },                
    { 
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "help" */ './views/about.vue')
    },        
    { 
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "help" */ './views/help.vue')
    }, 
    {
      path: '/404',
      name: '404',
      component: errorPage
    },
    {
      path: '*', redirect: '/404'
    }   
  ]
})
